import { useEffect, useRef } from "react";
import { MAIN_DEFAULT_LOOK } from "../../shared/character";
import { Perso } from "../components/avatar";
import { ErrorNotice, Loading } from "../components/ui";
import { useMachines } from "../lib/agent";
import { usePageTitle } from "../lib/hooks";
import { agentSocket } from "../lib/socket";
import { CloudScreen } from "./computer";

/**
 * /ecran — the cloud computer's live screen alone, on a dark ground, without the app's shell: the view the native app
 * (iOS / macOS, docs/design/APP-APPLE.md) shows in a web view, and a full-window view on the web. Same screen as
 * /ordinateur (noVNC, agents' cursors, « Prendre la main »): an off computer starts by itself once per visit.
 */
export function ScreenOnlyPage() {
  usePageTitle("Écran en direct");
  const machines = useMachines();
  const startOnce = useRef(false);

  // The shell owns the realtime socket in the app; this page has no shell, so it opens its own (machine.upsert events).
  useEffect(() => {
    agentSocket.start();
    return () => agentSocket.stop();
  }, []);

  const cloud = (machines.data ?? []).find((m) => m.kind === "cloud");
  return (
    <main className="min-h-dvh bg-bg px-5 py-4 text-fg">
      {machines.loading ? <Loading /> : null}
      {machines.error ? <ErrorNotice message={machines.error.message} onRetry={() => void machines.reload()} /> : null}
      {!machines.loading && !machines.error && !cloud?.liveView ? (
        <div className="mt-24 flex flex-col items-center gap-4">
          <Perso look={MAIN_DEFAULT_LOOK} size={96} asleep />
          <p className="text-center text-[15px] text-muted">Pas d'ordinateur à afficher.</p>
        </div>
      ) : null}
      {cloud?.liveView ? <CloudScreen machine={cloud} startOnce={startOnce} /> : null}
    </main>
  );
}
